import angular from 'angular';

AuthenticationService.$inject = ['$http', '$cookies', '$base64', 'appconfig'];

function AuthenticationService($http, $cookies, $base64, appconfig) {

    var service = {};

    service.logout = logout;
    service.login = login;
    service.isAuthenticated = isAuthenticated;
    service.getProfile = getProfile;
    service.getUsername = getUsername;

    return service;

    /**
     * logout(cb)
     * @cb
     */
    function logout(callback) {
        $http({method: 'GET', url: appconfig.apiEndpoint + '/logout'}).then(function(response) {
            callback(true);
        }, function(err) {
            if (err) console.log(err.message || err);
            callback(false);
        });
    }
    /**
     * login(username, password, cb)
     * @username
     * @password
     * @cb
     */
    function login(identifier, password, callback) {
        var auth = $base64.encode(identifier + ':' + password);
        $http({method: 'POST', url: appconfig.apiEndpoint + '/auth/local', headers: {'Authorization': 'Basic ' + auth}}).then(function(response) {
            if (response.data.success) {
                callback(true);
            } else {
                callback(false);
            }
        }, function(err) {
            if (err) console.log(err.message || err);
            callback(false);
        });
    }
    /**
     * profile(callback)
     */
    function getProfile(callback) {
        $http({
            method: 'GET',
            url: appconfig.apiEndpoint + '/auth/profile'
        }).then(function(response) {
            callback(null, response.data);
        }, function(err) {
            if (err) console.log(err.message || err);
            callback(err, null);
        });
    }
    function isAuthenticated() {
        var currentUser = $cookies.get('currentUser');
        return !(currentUser === undefined);
    }

    function getUsername() {
        return $cookies.get('currentUser');
    }

}

export default angular.module('authentication.service', [])
    .factory('AuthenticationService', AuthenticationService)
    .name;
